import React, { useState } from "react";
import SmallModal from "./modal/SmallModal";
import { pinverifyAPI } from "../utils/apis";
import axios from "axios";
import Input from "./inputs/Input";
import { BackButton } from "./btn/Buttons";
import Button from "./btn/Button";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

export const PinVerify = React.memo(
  ({
    showPinVerify,
    setShowPinVerify,
    setShowLoader,
    setAlertOpen,
    setAlertMess,
    closeBTN = false,
  }) => {
    const [pin, setPin] = useState("");
    const { pin_data, emp_pin_data } = useSelector((state) => state.profile);
    const { user_id, emp_id, user_type } = useSelector((state) => state.other);

    const navigate = useNavigate();

    const handlePinSubmit = async () => {
      if (pin.length == 4) {
        setShowLoader(true);
        const body = new FormData();
        body.append(
          "action",
          user_type == "admin" ? "pinverify" : "emppinverify"
        );
        body.append("agencyid", user_id);
        body.append("pin", pin);

        if (emp_id) {
          body.append("emp_code", emp_id);
        }

        const response = await axios.post(pinverifyAPI, body);
        setShowLoader(false);
        if (response.data.success) {
          setShowPinVerify(false);
          setPin("");
        } else {
          setAlertOpen(true);
          setAlertMess(response.data.message);
          setPin("");
        }
      } else {
        if (pin.length == 0) {
          setAlertMess("Please Enter Pin");
        } else if (pin.length >= 3 && pin.length <= 5) {
          setAlertMess("Pin contain 4 digit only");
        }
        setAlertOpen(true);
      }
    };
    return (
      <SmallModal
        closeBtnHide={closeBTN}
        okBtnHide={false}
        isOpen={showPinVerify}
        setIsOpen={setShowPinVerify}
        style={{ minWidth: "30rem" }}
        okbtn={setShowPinVerify}
        title={"ENTER SECURITY PIN DETAILS"}
        mess={
          (user_type == "admin" && pin_data == 0) ||
          (user_type == "employee" && emp_pin_data == 0) ? (
            <div className="pin-ver">
              <div
                className="pin-ver-1st"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    width: "70%",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  Please Set Pin First
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ width: "fit-content", margin: "1.5rem 0" }}>
                  <BackButton />
                </div>
                <div style={{ width: "fit-content", margin: "1.5rem 0" }}>
                  <Button
                    onClick={() =>
                      navigate(
                        user_type == "admin"
                          ? "/profile/Settinginfo"
                          : "/profile/Ainfo"
                      )
                    }
                    title={"PROFILE"}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="pin-ver">
              <div
                className="pin-ver-1st"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    width: "70%",
                    display: "flex",
                    justifyContent: "space-evenly",
                    alignItems: "center",
                  }}
                >
                  <label
                    className="pin-lable"
                    style={{ width: "30%", fontSize: "14px" }}
                  >
                    Pin Number:
                  </label>
                  <div className={"pin-input-div"} style={{ width: "70%" }}>
                    <Input
                      type={"password"}
                      placeholder={"Enter Pin Here"}
                      value={pin}
                      onChange={(event) => {
                        const numericValue = event.target.value.replace(
                          /[^0-9]/g,
                          ""
                        );
                        if (numericValue?.length <= 4 || numericValue == "") {
                          setPin(numericValue);
                        }
                      }}
                    />
                  </div>
                </div>
                <div style={{ width: "fit-content", padding: "0 5% " }}>
                  <Button onClick={handlePinSubmit} title={"SUBMIT"} />
                </div>
              </div>
              <div style={{ width: "fit-content", margin: "1.5rem 0" }}>
                <BackButton />
              </div>
            </div>
          )
        }
      />
    );
  }
);
